module.exports = __webpack_public_path__ + "static/media/play-button.06b32d27.png";